import type { FC, ReactNode } from 'react';

import Logo from '@/components/Logo';

interface LayoutProps {
  children: ReactNode;
}

export const InitAuthLayout: FC<LayoutProps> = (props) => {
  const { children } = props;

  return (
    <div
      className="tw:flex tw:flex-auto tw:flex-col tw:h-full tw:bg-background"
      style={{
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        backgroundImage: 'url("/assets/gradient-bg.svg")',
      }}
    >
      <header className="tw:fixed tw:left-0 tw:right-0 tw:top-0 tw:p-2 tw:z-[1100]">
        <div className="tw:container tw:max-w-screen-lg tw:mx-auto tw:px-6">
          <Logo />
        </div>
      </header>

      <div className="tw:flex tw:flex-col tw:items-center tw:gap-4">{children}</div>
    </div>
  );
};
